import { useEffect, useState } from "react";
import {
  apiCall,
  apiCallResponse,
  apiCallSPPost,
  apiExportToExcel,
} from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import CommonList from "src/views/common/CommonList";

import {
  CommonSearch,
  SCDate,
  SCInput,
  SCSelect,
  updateSearchStatus,
} from "src/views/common/CommonSearch";
import TableButtonClick from "src/views/common/Table/TableButtonClick";

const PBSMSBankGauranteeReceivedReport = () => {
  const { authenticated } = Auth();
  const [usersData, setUsersData] = useState(); // List Data Set
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [isExporting, setIsExporting] = useState(false); //Export To Excel Loader Manage

  const SearchFilterModel = {
    collectionSeason:  new Date().getFullYear().toString(),
    tenderNo: "",
    lotNo: "",
    circleId: 0,
    disctrictId: 0,
    requestType: 0,
    companyName: "",
    bgid: "",
    mobile: "",
    expiryStartDate: "",
    expiryEndDate: "",
    date: "",
  };

  const [search, setSearch] = useState(SearchFilterModel); // Search Model

  const [itemsCircle, setItemsCircle] = useState([]);
  const [itemsDistrict, setItemsDistrict] = useState([]);

  // Page  API URL manage
  const ReportListUrl = `Report/PBSMS/Bank_Gaurntee_Received`;
  const ReportListCountUrl = `Report/PBSMS/Bank_Gaurntee_Received/count`;
  const ReportListExcelUrl = `Report/PBSMS/Bank_Gaurntee_Received/ExportToExcel`;
  const ReportListExcelFileName = "PBSMSBankGaurnteeReceivedReport.xls";

  // api data manage
  const getdata = (setPageLimits = "", setItemPerPages = "") => {
    let setCircleId = Number(search.circleId);
    let setDisctrictId = Number(search.disctrictId);
    if (authenticated.role === "CFO") {
      setCircleId = authenticated?.district;
    }

    if (authenticated.role === "DFO") {
      setDisctrictId = authenticated?.district;
    }
    return JSON.stringify({
      start: setPageLimits === "" ? pageLimit : setPageLimits,
      length: setItemPerPages === "" ? itemPerPage : setItemPerPages,
      collection_season: Number(search.collectionSeason),
      tender_no: search.tenderNo.trim(),
      circle_id: setCircleId,
      district_id: setDisctrictId,
      lot_no: search.lotNo.trim(),
      request_type: Number(search.requestType),
      company_name: search.companyName.trim(),
      bgid: search.bgid.trim(),
      mobile: search.mobile.trim(),
      expiry_start_date: search.expiryStartDate.trim(),
      expiry_end_date: search.expiryEndDate.trim(),
      date: search.date,
    });
  };

  useEffect(() => {
    setloading(true);
    reset();
    getReportCount(true);

    if (authenticated.role === "CGMF") {
      getCircleList();
      getDistrictList(0);
    }

    if (authenticated.role === "CFO") {
      getDistrictList(authenticated?.district);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getReportList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit]);

  useEffect(() => {
    if (isSearch) {
      getReportList();
      getReportCount();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Disabled Manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // get Report List
  const getReportList = async () => {
    if (authenticated) {
      setloading(true);
      paggingDisabled();
      setUsersData();

      await apiCallSPPost(ReportListUrl, getdata(), [])
        .then((res) => {
          if (res.success) {
            setUsersData(res.data);

            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          } else setUsersData();
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  // get Report List Count
  const getReportCount = async () => {
    if (authenticated) {
      await apiCallSPPost(ReportListCountUrl, getdata(0, 0), 0).then((res) => {
        if (res.success) paggingManage(parseInt(res.totalRecord) || 0);
        else paggingManage(0, false);
      });
    }
  };
  // get Report List ExportToExcel
  const ExportToExcel = async () => {
    setIsExporting(true);
    try {
      await apiExportToExcel(
        pageCount,
        ReportListExcelUrl,
        getdata(0, 0),
        ReportListExcelFileName
      ).finally(() => {
        setIsExporting(false);
      });
    } catch (error) {
      // Handle any errors that might occur during the export process
      console.error("Error exporting to Excel:", error);
      setIsExporting(false); // Reset isExporting state if an error occurs
    }
  };

  const reset = () => {
    setpageLimit(0);
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };

  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUsersData();
  };

  const getCircleList = async () => {
    await apiCallResponse(`Circle_Master`).then((res) => {
      if (res.success) {
        const Data = res.data
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item, key) => ({
            value: item.circleId,
            label: item.name,
          }));
        setItemsCircle(Data);
      } else setItemsCircle([]);
    });
  };

  const getDistrictList = async (circleId = 0) => {
    let filter = "";

    if (circleId !== "" && circleId !== undefined && parseInt(circleId) > 0) {
      filter = "?$filter= circleId eq " + circleId;
    }
    await apiCallResponse(`District_Master${filter}`, "GET").then((res) => {
      if (res.success) {
        const DistrictData = res.data
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item, key) => ({
            value: item.districtId,
            label: item.name,
          }));
        setItemsDistrict(DistrictData);
      } else setItemsDistrict([]);
    });
  };
  const handleChangeCircle = (e, id) => {
    const value = e.target.value;
    updateSearch(e, "disctrictId", 0);
    setItemsDistrict([]);
    getDistrictList(value);
  };

  const BGPaymentStatusViewHanlder = async (filePath) => {
    const header = new Headers();
    const response = await apiCall(
      `Report/DownloadBGReceipt?filepath=${filePath}`,
      "GET",
      header,
      null
    );
    const jsonobj = await response;

    if (jsonobj.status === 200) {
      jsonobj.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = filePath;
        alink.click();
      });
    } else {
      alert("Receipt not availabe");
    }
  };
  const RequestTypeList = [
    { value: "5", label: "EMD" },
    { value: "6", label: "Access Benefit Sharing" },
    { value: "7", label: "Add. SD 60%" },
    { value: "12", label: "Lot Transfer EMD" },
  ];

  const SearchExtraControl = (
    <>
      {authenticated.role === "CGMF" && (
        <SCSelect
          labelname="Circle Name"
          name="circleId"
          value={search.circleId}
          onChange={handleChangeCircle}
          items={itemsCircle}
          isSelectShow={true}
        />
      )}
      {(authenticated.role === "CGMF" || authenticated.role === "CFO") && (
        <SCSelect
          labelname="Disctrict"
          name="disctrictId"
          value={search.disctrictId}
          onChange={updateSearch}
          items={itemsDistrict}
          isSelectShow={true}
        />
      )}

      <SCInput
        label={"Lot Number : "}
        name={"lotNo"}
        value={search.lotNo}
        onChange={updateSearch}
      />
      <SCSelect
        labelname="Request Type"
        name="requestType"
        value={search.requestType}
        onChange={updateSearch}
        items={RequestTypeList}
      />

      <SCInput
        label={"Company Name : "}
        name={"companyName"}
        value={search.companyName}
        onChange={updateSearch}
      />
      <SCInput
        label={"Bank Gaurantee / FDR Number : "}
        name={"bgid"}
        value={search.bgid}
        onChange={updateSearch}
      />
      <SCInput
        label={"Mobile : "}
        name={"mobile"}
        value={search.mobile}
        onChange={updateSearch}
      />
      <SCDate
        label="Expiry Start Date"
        name={"expiryStartDate"}
        value={search.expiryStartDate}
        onChange={updateSearch}
        maxDate={search.expiryEndDate}
      />
      <SCDate
        label="Expiry End Date"
        name={"expiryEndDate"}
        value={search.expiryEndDate}
        onChange={updateSearch}
        minDate={search.expiryStartDate}
      />
    </>
  );
  //Search Filter Manage ( UI also)
  const additional = (
    <>
      <CommonSearch
        isDisabledSearchClear={loading}
        isClear={isClear}
        search={search}
        updateSearch={updateSearch}
        searchButton={searchButton}
        clearSearch={clearSearch}
        itemPerPage={itemPerPage}
        onChangePage={onChangePage}
        extraControl={SearchExtraControl}
        isExportToExcelDisplay={true}
        isExporting={isExporting}
        isDisabledExport={usersData && usersData.length > 0 ? false : true}
        ExportToExcel={ExportToExcel}
      />
    </>
  );

  let scopedSlotsList = {
    viewBGPaymentReceipt: (item, index) => {
      return (
        <TableButtonClick
          buttonName={"View Receipt"}
          color={"info"}
          isNormallBtn={true}
          isDisplayAllow={item.filePathUrl !== "" && item.filePathUrl !== null}
          onClick={() => BGPaymentStatusViewHanlder(item.filePath)}
        />
      );
    },
  };
  const fields = [
    {
      key: "srNo",
      _style: { width: "2%" },
      label: "S.N.",
    },
    {
      key: "circleName",
      _style: { width: "5%" },
      label: "Circle",
    },
    {
      key: "districtName",
      _style: { width: "5%" },
      label: "District Union",
    },
    {
      key: "lotNo",
      _style: { width: "5%" },
      label: "Lot No.",
    },

    {
      key: "actualQuantity",
      _style: { width: "7.5%" },
      label: "Actual Quantity (Per STD Bags)",
    },
    {
      key: "saleRate",
      _style: { width: "6.5%" },
      label: "Sale Rate",
    },
    {
      key: "saleValue",
      _style: { width: "6.5%" },
      label: "Sale Value",
    },
    {
      key: "typeName",
      _style: { width: "6.5%" },
      label: "Request Type ",
    },
    {
      key: "companyName",
      _style: { width: "15%" },
      label: "Company Name",
    },
    {
      key: "requestDate",
      _style: { width: "7.5%" },
      label: "Request Date",
    },

    {
      key: "bgid",
      _style: { width: "7.5%" },
      label: "Bank Gaurantee / FDR Number",
    },
    {
      key: "amount",
      _style: { width: "5%" },
      label: "Bank Gaurantee / FDR Amount (In Rs.)",
    },
    {
      key: "mobile",
      _style: { width: "7.5%" },
      label: "Mobile",
    },
    {
      key: "bgDueDate",
      _style: { width: "7.5%" },
      label: "Expiry Date",
    },
    {
      key: "viewBGPaymentReceipt",
      label: "View Receipt",
      _style: { width: "20%" },
      sorter: false,
      filter: false,
    },
  ];
  const HeaderBind = (role) => {
    if (role === "CGMF") {
      return "Bank Gaurantee Received Report";
    } else if (role === "CFO" || role === "DFO") {
      return "BG Payment Report";
    }
  };
  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName={HeaderBind(authenticated.role)}
      loading={loading}
      additional={additional}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      id="userid"
      scopedSlots={scopedSlotsList}
    />
  );
};

export default PBSMSBankGauranteeReceivedReport;
